<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Movimientos de Nómina</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <k-table
          :deleteButton="puede_anular"
          :createButton="puede_registrar"
          :editButton="false"
          ref="movimientos"
          @crear="crear"
          :path="path"
          @eliminar="eliminar"
          :columns="[
            {
              display: 'Fecha',
              value: 'fecha',
            },
            {
              display: 'Valor',
              value: 'valor',
              numeric: true,
            },
            {
              display: 'Sucursal',
              value: 'bodega.descripcion',
            },
            {
              display: 'Oficinista',
              value: 'oficinista.nombre',
            },
            {
              display: 'Persona',
              value: 'persona.nombre',
            },
            {
              display: 'Vendedor',
              value: 'vendedor.descripcion',
            },
            {
              display: 'Detalle',
              value: 'detalle',
            },
            {
              display: 'Tipo de movimiento',
              value: 'tipo_movimiento.descripcion',
            },
            {
              display: 'Creación',
              value: 'created_at',
            },
          ]"
        ></k-table>
      </div>
    </div>
    <modal
      name="movimiento"
      scrollable
      resizable
      reset
      adaptive
      height="auto"
      width="60%"
    >
      <movimiento
        :bodegas="bodegas"
        :tiposMovimiento="tiposMovimiento"
        @cancelar="cancelar"
        @saved="savedMovimiento"
        ref="movimiento"
        v-model="selectedMovimiento"
      ></movimiento>
    </modal>
  </div>
</template>

<script>
import Movimiento from "./Movimiento.vue";
export default {
  components: {
    Movimiento,
  },
  data: function () {
    return {
      path: url + "/movimientos-nomina",
      selectedMovimiento: null,
      bodegas: [],
      tiposMovimiento: [],
      puede_anular: false,
      puede_registrar: false
    };
  },
  methods: {
    cargarDatos: function () {
      axios
        .get(url + "/movimientos-nomina/datos")
        .then(({ data }) => {
          this.bodegas = data.bodegas;
          this.tiposMovimiento = data.tiposMovimiento;
          this.puede_anular = data.puede_anular;
          this.puede_registrar = data.puede_registrar;
        })
        .catch(() => {
          swal("Hubo un error al cargar los datos.", "Error", "error");
        });
    },
    cancelar: function () {
      this.$modal.hide("movimiento");
    },
    savedMovimiento: function () {
      this.$modal.hide("movimiento");
      this.$refs.movimientos.loadRows();
    },
    crear: function () {
      this.selectedMovimiento = {
        valor: "",
        detalle: "",
        bodega_id: "",
        tipo_movimiento_id: "",
        fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        persona_id: '',
        vendedor_id: ''
      };
      this.$modal.show("movimiento");
    },
    eliminar: function (movimiento) {
      swal({
        title: "¿Deseas anular el movimiento de oficina seleccionado?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/movimientos-nomina/" + movimiento.id, {
              _method: "DELETE",
            })
            .then(() => {
              swal(
                "El movimiento ha sido anulado exitósamente.",
                "Realizado",
                "success"
              );
              this.$refs.movimientos.loadRows();
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
  },
  mounted: function () {
    this.cargarDatos();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/ListaMovimientos.vue